import { PROGRESS_COLORS, PROGRESS_THRESHOLDS } from "../constants/time";

export const getProgressColor = (percentage) => {
  if (percentage >= PROGRESS_THRESHOLDS.DANGER) return PROGRESS_COLORS.DANGER;
  if (percentage >= PROGRESS_THRESHOLDS.WARNING) return PROGRESS_COLORS.WARNING;
  return PROGRESS_COLORS.SUCCESS;
};

export const calculateEstimateProgress = (timeEstimate, totalTimeSpent = 0) => {
  if (!timeEstimate || timeEstimate <= 0) {
    return { percentage: 0, color: PROGRESS_COLORS.SUCCESS, exceeded: false };
  }

  const percentage = Math.min((totalTimeSpent / timeEstimate) * 100, 100);
  const beyondPercentage =
  percentage >= 100
    ? Math.min(((totalTimeSpent - timeEstimate) / timeEstimate) * 100, 100)
    : 0;

  return {
    percentage,
    color: getProgressColor(percentage),
    exceeded: percentage >= 100,
    beyondPercentage,
    beyondColor: getProgressColor(beyondPercentage) || PROGRESS_COLORS.BEYOND,
  };
};

export const calculateDueProgress = (dueDate, assignEpoch, currentTime) => {
  if (!dueDate || !assignEpoch) {
    return { percentage: 0, color: PROGRESS_COLORS.SUCCESS };
  }

  const totalTimeToDue = dueDate - assignEpoch;
  const timeElapsed = currentTime - assignEpoch;
  const percentage = Math.min((timeElapsed / totalTimeToDue) * 100, 100);

  return {
    percentage,
    color: getProgressColor(percentage),
    overdue: percentage >= 100,
  };
};
